var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userAvatar"},[_c('Avatar',{staticClass:"userAvatar__image",attrs:{"user":_vm.icon}}),_c('AtomSpan',{staticClass:"userAvatar__userCheck",attrs:{"defaultText":_vm.defaultText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }